import { Fragment } from "react";

import noAccessSvg from "@impero-com/common/img/no-access-icon.svg";
import { t } from "@impero-com/common/utils/i18n";
import { Button, FormFrame, Svg } from "@impero-com/ui";

import * as theme from "./theme.css";

export const NoAccessCard = ({ inline }: { inline?: boolean }) => {
    const Frame = inline ? Fragment : FormFrame;
    return (
        <Frame>
            <div className={theme.card}>
                <NoAccessCardContent
                    detail={t("NoAccessCard_InsufficientAccessDetail")}
                />
                <Button
                    id="go-back"
                    variant="link"
                    onClick={() => window.history.back()}
                >
                    {t("GoBack")}
                </Button>
            </div>
        </Frame>
    );
};

interface ContentProps {
    detail: string;
}
export const NoAccessCardContent = ({ detail }: ContentProps) => (
    <>
        <div>
            <Svg src={noAccessSvg} className={theme.noAccessSvg} />
        </div>
        <br />
        <div className={theme.content}>
            <div>
                <b>{t("NoAccessCard_InsufficientAccess")}</b>
            </div>
            <div>{detail}</div>
        </div>
        <br />
    </>
);
